/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thin_Swift_Bat_RaceInputs */

const en_thin_swift_bat_race = /** @type {(inputs: Thin_Swift_Bat_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content deleted`)
};

const de_thin_swift_bat_race = /** @type {(inputs: Thin_Swift_Bat_RaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt gelöscht`)
};

/**
* | output |
* | --- |
* | "Content deleted" |
*
* @param {Thin_Swift_Bat_RaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const thin_swift_bat_race = /** @type {((inputs?: Thin_Swift_Bat_RaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thin_Swift_Bat_RaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thin_swift_bat_race(inputs)
	return de_thin_swift_bat_race(inputs)
});